import React from 'react';
import { UserAvatar } from 'features/users';

export const AvatarGroup = ({ users = [], icon }) => (
  <div className="relative flex items-center">
    <div className="flex -space-x-2">
      {users.map((user, idx) => (
        <UserAvatar
          key={user.userId || idx}
          userId={user.userId}
          className="w-7 h-7 rounded-full ring-2 ring-white"
        />
      ))}
    </div>
    {icon && (
      <div className="absolute -bottom-1 left-6 bg-[#0E3061] p-1.5 rounded-full border-2 border-white w-6 h-6 flex items-center justify-center shadow-md">
        <img src={icon} alt="Icon" className="w-4 h-4" />
      </div>
    )}
  </div>
);
